module.exports = __webpack_public_path__ + "src/assets/games/18/218.jpg";